/* src/app/shared/components/message-handler/message-handler.component.scss */
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
::-webkit-scrollbar-thumb {
  background: #acacac;
  border-radius: 8px;
}
::-webkit-scrollbar-track {
}
body {
  scrollbar-face-color: #acacac;
  scrollbar-track-color: rgb(213.5, 213.5, 213.5);
}
.message-handler-wrapper {
  position: absolute;
  width: 100%;
  z-index: 9999;
}
.message-handler-wrapper .message-display {
  top: 0px;
  left: 0px;
  width: 100%;
  position: absolute;
  height: 71px;
  opacity: 1;
}
.message-handler-wrapper .message-header {
  top: -0.9752044678px;
  left: 0px;
  width: 100%;
  height: 6px;
  opacity: 1;
}
.message-handler-wrapper .success {
  background-color: #457a1a;
}
.message-handler-wrapper .success span {
  font-weight: bold;
}
.message-handler-wrapper .message-header-success {
  background-color: #457a1a;
}
.message-handler-wrapper .error {
  background-color: #B13741;
}
.message-handler-wrapper .message-header-error {
  background-color: #7E2A31;
}
.message-handler-wrapper .warn {
  background-color: #ffe85f;
}
.message-handler-wrapper .message-header-warn {
  background-color: #d2c26e;
}
.message-handler-wrapper .message {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.message-handler-wrapper .message mat-card {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  align-items: center;
  display: flex;
  flex-direction: column;
  color: white;
  position: absolute;
  z-index: 2;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
  max-width: 45%;
  width: auto;
}
.message-handler-wrapper .message mat-card .card-content-container span {
  letter-spacing: 1px;
  padding-top: 2px;
  font-weight: bold;
}
.message-handler-wrapper .message mat-card .card-content-container p {
  align-items: center;
  padding-top: 2px;
  padding-bottom: 4px;
}
.message-handler-wrapper .message mat-card .card-content-container {
  display: flex;
  flex-direction: row;
}
.message-handler-wrapper .message mat-card mat-icon {
  padding-right: 8px;
  vertical-align: top;
}
.message-handler-wrapper .message mat-card .mat-icon-button {
  margin-left: 8px;
  align-items: center;
}
.message-handler-wrapper .message mat-card .mat-icon-button mat-icon {
  height: 14px;
  width: 14px;
  padding: 0;
}
.message-handler-wrapper .message mat-card span {
  padding-right: 8px;
}
.message-handler-wrapper .message mat-card p {
  flex-grow: 1;
  margin: 0px;
  padding-right: 8px;
}
.message-handler-wrapper .message mat-card button {
  height: fit-content;
  min-width: auto;
  line-height: normal;
  margin: 0px;
  padding: 0px;
}
/*# sourceMappingURL=message-handler.component.css.map */
